<template>
  <g>
    <!-- Handles for polygon locations -->
    <g v-if="selectedLocation.is_polygon">
      <circle
        v-for="(point, i) in selectedLocation.points"
        :key="i"
        :cx="point[0]"
        :cy="point[1]"
        r="50"
        fill="#ffffff"
        stroke="#000000"
        stroke-width="5"
        @pointerdown.prevent="setPolyPointMoving(i)"
        class="cursor-move"
      />
    </g>
    <!-- Handles for rectangular locations -->
    <g v-else>
      <!-- Top handle for resizing the top edge -->
      <rect
        :x="selectedLocation.x + selectedLocation.width / 2 - 50"
        :y="selectedLocation.y - 50"
        width="100"
        height="100"
        fill="#ffffff"
        stroke="#000000"
        stroke-width="5"
        ref="topHandle"
        class="cursor-row-resize"
      />
      <!-- Right handle for resizing the right edge -->
      <rect
        :x="selectedLocation.x + selectedLocation.width - 50"
        :y="selectedLocation.y + selectedLocation.depth / 2 - 50"
        width="100"
        height="100"
        fill="#ffffff"
        stroke="#000000"
        stroke-width="5"
        ref="rightHandle"
        class="cursor-col-resize"
      />
      <!-- Bottom handle for resizing the bottom edge -->
      <rect
        :x="selectedLocation.x + selectedLocation.width / 2 - 50"
        :y="selectedLocation.y + selectedLocation.depth - 50"
        width="100"
        height="100"
        fill="#ffffff"
        stroke="#000000"
        stroke-width="5"
        ref="bottomHandle"
        class="cursor-row-resize"
      />
      <!-- Left handle for resizing the left edge -->
      <rect
        :x="selectedLocation.x - 50"
        :y="selectedLocation.y + selectedLocation.depth / 2 - 50"
        width="100"
        height="100"
        fill="#ffffff"
        stroke="#000000"
        stroke-width="5"
        ref="leftHandle"
        class="cursor-col-resize"
      />
    </g>
  </g>
</template>

<script setup>
import { ref, defineExpose } from 'vue';

// Define props
defineProps({
  selectedLocation: { type: Object, required: true },
});

// Define emitted events
const emits = defineEmits(['setPolyPointMoving']);

// Emit event to set polygon point moving
function setPolyPointMoving(i) {
  emits('setPolyPointMoving', i);
}

// Refs for rectangular handles
const topHandle = ref(null);
const rightHandle = ref(null);
const bottomHandle = ref(null);
const leftHandle = ref(null);

// Expose handles to parent components
defineExpose({
  topHandle,
  rightHandle,
  bottomHandle,
  leftHandle,
});
</script>
